export default ({ request }) => ({
  masterCustomerBizTeamSetListApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/list',
      method: 'post',
      data,
    })
  },
  masterCustomerBizTeamSetListByCustomerApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/listByCustomer',
      method: 'post',
      data,
    })
  },
  masterCustomerBizTeamSetDetailApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerBizTeamSetAddUserApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/addUser',
      method: 'post',
      data,
    })
  },
  masterCustomerBizTeamSetAddCustomerApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/addCustomer',
      method: 'post',
      data,
    })
  },
  masterCustomerBizTeamSetDelApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/del',
      method: 'post',
      data,
    })
  },
  masterCustomerBizTeamSetUpdateApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/update',
      method: 'post',
      data,
    })
  },
  masterCustomerBizTeamSetChangeUserApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/changeUser',
      method: 'post',
      data,
    })
  },
  masterCustomerBizTeamSetRemoveUserApi(data) {
    return request({
      url: '/digitalCenter/master/customer/biz/team/set/removeUser',
      method: 'post',
      data,
    })
  },
})
